import { IPageStatus } from '../../config/IPageStatus';
import { useProductStore } from '../../ProductProvider';

export const isStatusA = () => {
    const { pageStatus } = useProductStore();

    return pageStatus === IPageStatus.statusA;
};

export const isStatusB = () => {
    const { pageStatus } = useProductStore();
    console.log(pageStatus);

    return pageStatus === IPageStatus.statusB;
};
